import { render, staticRenderFns } from "./reporting.vue?vue&type=template&id=fed441a6"
import script from "./reporting.ts?vue&type=script&lang=ts&external"
export * from "./reporting.ts?vue&type=script&lang=ts&external"
import style0 from "./reporting.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fed441a6')) {
      api.createRecord('fed441a6', component.options)
    } else {
      api.reload('fed441a6', component.options)
    }
    module.hot.accept("./reporting.vue?vue&type=template&id=fed441a6", function () {
      api.rerender('fed441a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/reporting/reporting.vue"
export default component.exports